




import React from 'react';
import { Formik, Form, FieldArray } from 'formik';
import InputSelect from 'src/components/shared/Form/Select';
import DateTimePicker from 'src/components/App/DatePicker';
import SwitchComponent from 'src/components/shared/Form/Switch';
import theme from 'src/config/theme';
import { Box } from '@mui/material';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { ReactComponent as Add } from '../../../../../assets/images/add-square.svg';
import { ReactComponent as Remove } from '../../../../../assets/images/close-circle.svg';
import useResponsive from 'src/components/hooks/useResponsive';
import {
    AddContainer,
    Component4,
    Texts,
    Component2,
    InnerComponent,
    SaveButton,
    RemoveButton
} from './Styles';

dayjs.extend(customParseFormat);

const Days = [
    { label: 'Monday', value: 'monday' },
    { label: 'Tuesday', value: 'tuesday' },
    { label: 'Wednesday', value: 'wednesday' },
    { label: 'Thursday', value: 'thursday' },
    { label: 'Friday', value: 'friday' },
    { label: 'Saturday', value: 'saturday' },
    { label: 'Sunday', value: 'sunday' },
];

const DoctorTimingStep = ({ data, innerRef, setDoctorProfileData, onStepSubmitSuccess }) => {
    const { isMobile, isTablet } = useResponsive();
    const Width = isMobile || isTablet ? '18px' : '24px';
    const Height = isMobile || isTablet ? '18px' : '24px';
    const parseTime = (timeStr) => {
        if (!timeStr) return null;
        const normalized = timeStr.replace(/\./g, '').toUpperCase();
        const formats = ['h A', 'h:mm A', 'hh:mm A', 'HH:mm', 'hA', 'ha'];
        for (let format of formats) {
            const parsed = dayjs(normalized, format, true);
            if (parsed.isValid()) return parsed.toDate();
        }
        return null;
    };

    const initialValues = React.useMemo(() => {
        let processedTimings = [];
        try {
            if (Array.isArray(data?.timings) && data.timings.length > 0) {
                const seen = new Set();
                const uniqueData = data.timings.filter(item => {
                    const key = `${item?.day}-${item?.startTime}-${item?.endTime}`;
                    if (seen.has(key)) return false;
                    seen.add(key);
                    return true;
                }).slice(0, 50);

                processedTimings = uniqueData.map((t) => ({
                    ...t,
                    startTime: parseTime(t.startTime),
                    endTime: parseTime(t.endTime),
                }));
            }
        } catch (error) {
            console.error(error);
        }

        return {
            timings: processedTimings,
            acceptingAppointments: data?.acceptingAppointments === 'yes',
        };
    }, [data?.timings?.length, data?.acceptingAppointments]);

    const handleSubmit = (values) => {
        const formattedTimings = values.timings.map((t) => ({
            ...t,
            day: t.day?.value || t.day,
            startTime: dayjs(t.startTime).format('hh:mm A'),
            endTime: dayjs(t.endTime).format('hh:mm A'),
        }));

        setDoctorProfileData((prev) => ({
            ...prev,
            doctorTimings: {
                timings: formattedTimings,
                acceptingAppointments: values.acceptingAppointments ? 'yes' : 'no',
            },
        }));
        onStepSubmitSuccess()
    };


    return (
        <Formik initialValues={initialValues} onSubmit={handleSubmit} innerRef={innerRef} >
            {({ values, setFieldValue }) => (
                <Form>
                    <AddContainer sx={{ gap: '20px' }}>
                        <FieldArray name="timings">
                            {({ push, remove }) => (
                                <>
                                    {values.timings?.map((timing, index) => (
                                        <Component2 key={index}>
                                            <InnerComponent>
                                                <Texts>Day</Texts>
                                                <InputSelect
                                                    name={`timings[${index}].day`}
                                                    options={Days}
                                                    value={timing.day}

                                                    onChange={(val) => setFieldValue(`timings[${index}].day`, val)}

                                                    placeholder="Select"
                                                    variant="outlined"
                                                    sx={{
                                                        boxShadow: theme.shadows[1],
                                                        '& .MuiOutlinedInput-root': {
                                                            height: '52px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            borderRadius: '12px',
                                                        },
                                                    }}
                                                />
                                            </InnerComponent>

                                            <InnerComponent>
                                                <Texts>Start Time</Texts>
                                                <DateTimePicker
                                                    type="time"
                                                    value={timing.startTime}
                                                    onChange={(val) => setFieldValue(`timings[${index}].startTime`, val)}
                                                />
                                            </InnerComponent>

                                            <InnerComponent>
                                                <Texts>End Time</Texts>
                                                <DateTimePicker
                                                    type="time"
                                                    value={timing.endTime}
                                                    onChange={(val) => setFieldValue(`timings[${index}].endTime`, val)}
                                                />
                                            </InnerComponent>
                                            
                                            <RemoveButton onClick={() => remove(index)} sx={{ mt: isMobile ? "5px" : 3 }}>
                                                <Remove width={Width} height={Height} />
                                            </RemoveButton>
                                        </Component2>
                                    ))}

                                    <Box display="flex" justifyContent="flex-end" mt={2}>
                                        <SaveButton
                                            variant="outlined"
                                            onClick={() => {


                                                push({
                                                    day: '',
                                                    startTime: null,
                                                    endTime: null,
                                                });
                                            }}
                                            sx={{ mt: 2 }}

                                            startIcon={<Add width={Width} height={Height} sx={{ color: theme.palette.primary.main }} />}

                                        >Add </SaveButton>
                                    </Box>
                                </>
                            )}
                        </FieldArray>

                        <Component4
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                            }}
                        >
                            <Texts>Accepting Appointments</Texts>
                            <SwitchComponent
                                name="acceptingAppointments"
                                checked={values.acceptingAppointments}
                                onChange={() =>
                                    setFieldValue('acceptingAppointments', !values.acceptingAppointments)
                                }
                                sx={{ margin: 0, padding: 0 }}
                            />
                        </Component4>
                    </AddContainer>

                </Form>
            )}
        </Formik>
    );
};
export default DoctorTimingStep;






